import useUserPreference from "../../actions/user/useUserPreference.ts";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { hash } from "../../../../common/utils/string.ts";

// Set once on load to avoid weird timing issues
const today = new Date();

interface ServiceAnnouncementDismissInfo {
  messageHash: number;
}

/**
 * Date in chameleon is specified to be YYYY-MM-DD
 * @param date
 */
export function getServiceAnnouncementDateWithTimeZone(date: string): Date {
  return new Date(date + "T00:00:00");
}

export default function useVirtualStoreServiceAnnouncement(): [
  boolean,
  () => void,
] {
  const { VirtualStore } = useBrandLoaderData();
  const [dismissInfo, setDismissInfo] =
    useUserPreference<ServiceAnnouncementDismissInfo>(
      UserPreferenceKey.VirtualStoreServiceAnnouncementDismissInfo
    );

  const hasAllRequiredValues = [
    VirtualStore.companyId,
    VirtualStore.ServiceAnnouncement.enabled,
    VirtualStore.ServiceAnnouncement.title,
    VirtualStore.ServiceAnnouncement.body,
    VirtualStore.ServiceAnnouncement.startDate,
    VirtualStore.ServiceAnnouncement.endDate,
  ].every((val) => !!val);

  const startDate = getServiceAnnouncementDateWithTimeZone(
    VirtualStore.ServiceAnnouncement.startDate!
  );
  const endDate = getServiceAnnouncementDateWithTimeZone(
    VirtualStore.ServiceAnnouncement.endDate!
  );
  const isInDateRange = today > startDate && today < endDate;

  const messageHash = hash(
    VirtualStore.ServiceAnnouncement.startDate! +
      VirtualStore.ServiceAnnouncement.title! +
      VirtualStore.ServiceAnnouncement.body!
  );

  const shouldShow =
    hasAllRequiredValues &&
    isInDateRange &&
    messageHash !== dismissInfo?.messageHash;

  const onDismiss = () => {
    setDismissInfo({ messageHash });
  };

  return [shouldShow, onDismiss];
}
